import React, { useEffect, useRef } from "react";
import "./necklaces.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import imgLeft1 from "./images/layerLeft1.webp";
import imgLeft2 from "./images/layerLeft2.webp";
import imgRight1 from "./images/layerRight1.webp";
import imgRight2 from "./images/layerRight2.webp";
import videoNecklace from "./images/Colier.mp4";
export default function Necklaces() {
  gsap.registerPlugin(ScrollTrigger);

  let col1Ref = useRef(null);
  let col2Ref = useRef(null);
  let col3Ref = useRef(null);
  let col4Ref = useRef(null);
  let titleRef = useRef(null);

  return (
    <div className="necklaces-main">
      <div className="component-header" ref={(el) => (titleRef = el)}>
        <p>NASZYJNIKI</p>
      </div>
      <div className="component-images">
        <div className="component-column column-left">
          <div className="left-content">
            <div className="left-image-1" ref={(el) => (col2Ref = el)}>
              <img
                src={
                  "https://cdn.media.amplience.net/i/teilor/Natalia_Mica_Stanga_Pozitia2"
                }
                alt=""
              />
            </div>
            <div className="left-image-2" ref={(el) => (col1Ref = el)}>
              <img
                src={
                  "https://cdn.media.amplience.net/i/teilor/Natalia_Mare_Stanga_Pozitia2"
                }
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="component-column column-middle">
          <div className="middle-content">
            <div className="middle-image" />
            <div className="middle-video necklace-video">
              <a href="https://www.teilor.pl/naszyjnik-w-18k-bialego-zlota-z-brylantem-4-83ct-54180.html">
                {/* <video
                  className="middle-video"
                  playsinline="true"
                  autoplay="true"
                  loop="true"
                  muted="true"
                >
                  <source src={videoNecklace} type="video/mp4" />
                </video> */}
                <img
                  src="https://cdn1.teilor.pl/slir/w700//teilor.pl/cs-content/cs-photos/products/original/naszyjnik-w-18k-biaego-zota-z-brylantem-483ct_20206_1_1613734137.png"
                  alt=""
                />
              </a>
            </div>
          </div>
        </div>
        <div
          className="component-column column-right"
          ref={(el) => (col3Ref = el)}
        >
          <div className="right-content">
            <div className="right-image-1" ref={(el) => (col3Ref = el)}>
              <img
                src={
                  "https://cdn.media.amplience.net/i/teilor/Natalia_Mare_Dreapta_Pozitia2"
                }
                alt=""
              />
            </div>
            <div className="right-image-2" ref={(el) => (col4Ref = el)}>
              <img
                src={
                  "https://cdn.media.amplience.net/i/teilor/Natalia_Mica_Dreapta_Pozitia2"
                }
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div className="component-content">
        <div className="component-content-title">
          <p>wyrafinowana </p>
        </div>
        <div className="component-content-text">
          <p>
            {" "}
            Wytworna biżuteria - oprawą dla Twojego polotu. Twoja uroda będzie
            mienić się w jej wszystkich fasetkach. Teraz uchwycona w doskonałych
            szlifach kamieni.
          </p>
        </div>
      </div>
    </div>
  );
}
